import { Link, useLoaderData, useRevalidator } from "react-router-dom"; // Link kept for Stripe logo
import { PageTitle } from "./Controls/PageTitle";
import { Button } from "./Controls/Button";
import { Col, Container, Row } from "react-bootstrap";
import { useState } from "react";
import { PaymentMethodResp } from "./Data/ApiTypes";
import { PaymentMethodDisplay } from "./Controls/PaymentMethod";
import { CreditCard2Front, PlusLg } from "react-bootstrap-icons";
import { UserBillingAddMethodModal } from "./UserBillingAddMethodModal";
import { UserBillingCardDetailsModal } from "./UserBillingCardDetailsModal";
import { BillingPageLoaderData } from "./index";
import { filterPaymentMethodSubscriptions } from "./Data/Subscription";

export function UserBillingPage() {
    const { paymentMethods, subscriptions } = useLoaderData() as BillingPageLoaderData;
    const { revalidate }                      = useRevalidator();
    const [showAddModal, setShowAddModal]     = useState( false );
    const [showMoveModal, setShowMoveModal]   = useState( false );
    const [moveSourcePm, setMoveSourcePm]     = useState<PaymentMethodResp | null>( null );
    const [didSucceed, setDidSucceed]         = useState( false );
    const [selectedPm, setSelectedPm]         = useState<PaymentMethodResp | null>( null );

    const handleModalHide = () => {
        setShowAddModal( false );
        setShowMoveModal( false );
        setMoveSourcePm( null );
        if( didSucceed ) {
            setDidSucceed( false );
            revalidate();
        }
    };

    return <Container fluid>
        <UserBillingAddMethodModal
            show={showAddModal}
            onHide={handleModalHide}
            subscriptions={subscriptions}
            paymentMethods={paymentMethods}
            onSuccess={() => setDidSucceed( true )}
            mode="add"
        />
        {moveSourcePm && (
            <UserBillingAddMethodModal
                show={showMoveModal}
                onHide={handleModalHide}
                subscriptions={subscriptions}
                paymentMethods={paymentMethods}
                onSuccess={() => setDidSucceed( true )}
                mode="move"
                sourcePaymentMethodId={moveSourcePm.paymentMethodId}
                sourceSubscriptionIds={filterPaymentMethodSubscriptions( moveSourcePm.subscriptions ).map( s => s.subscriptionId )}
                initialSubscriptionIds={filterPaymentMethodSubscriptions( moveSourcePm.subscriptions )
                    .filter( s => !s.isUsageBasedBilling )
                    .map( s => s.subscriptionId )}
            />
        )}
        <UserBillingCardDetailsModal
            pm={selectedPm}
            onHide={() => setSelectedPm( null )}
            onDelete={revalidate}
            onMove={() => {
                setMoveSourcePm( selectedPm );
                setSelectedPm( null );
                setShowMoveModal( true );
            }}
        />

        <Row>
            <Col md="12">
                <div className="d-flex align-items-center justify-content-between gap-2 flex-wrap mb-1">
                    <div className="d-flex align-items-center gap-2">
                        <PageTitle className="mb-0">
                            Payment Methods
                        </PageTitle>
                        <Link to="https://docs.stripe.com/security" target="_blank" rel="noopener noreferrer">
                            <img src="/img/powered-by-stripe.svg" style={{ height: "1.1em" }} alt="Powered by Stripe" />
                        </Link>
                    </div>
                    {subscriptions.length > 0 && (
                        <Button
                            className="btn-main d-flex align-items-center gap-1"
                            size="sm"
                            onClick={() => setShowAddModal( true )}
                        >
                            
                            Add Payment Method
                        </Button>
                    )}
                </div>
                <div className="text-secondary mb-3" style={{ fontSize: "0.87rem" }}>
                    Your information is securely stored by <b>Stripe</b>
                </div>

                <Container className="g-0">
                    {paymentMethods.length === 0 ? (
                        <div className="card border-0" style={{ boxShadow: "0 1px 3px rgba(0,0,0,0.07)" }}>
                            <div className="card-body text-center text-muted py-5" style={{ fontSize: "0.9rem" }}>
                                <div
                                    className="rounded-circle d-flex align-items-center justify-content-center mx-auto mb-3"
                                    style={{ width: 72, height: 72, backgroundColor: "rgba(220, 53, 130, 0.12)" }}
                                >
                                    <CreditCard2Front size={30} style={{ color: "rgba(220, 53, 130, 0.5)" }} />
                                </div>
                                <div className="fw-semibold mb-1">No payment methods saved.</div>
                                <div className="mb-4 text-secondary">
                                    Add a payment method to your plans to enable auto-pay.{" "}
                                    <Link to="/user/plan">View your plans</Link>
                                </div>
                                {subscriptions.length > 0 && (
                                    <Button
                                        className="btn-main d-inline-flex align-items-center gap-1"
                                        size="sm"
                                        onClick={() => setShowAddModal( true )}
                                    >
                                      
                                        Add Payment Method
                                    </Button>
                                )}
                            </div>
                        </div>
                    ) : (
                        <div
                            className="mt-2"
                            style={{
                                display: "grid",
                                gridTemplateColumns: "repeat(auto-fill, minmax(170px, 1fr))",
                                gap: "1rem",
                            }}
                        >
                            {paymentMethods.map( p => (
                                <div key={p.paymentMethodId} role="button" className="zoom-small" style={{ cursor: "pointer" }} onClick={() => setSelectedPm( p )}>
                                    <PaymentMethodDisplay method={p} />
                                </div>
                            ) )}
                        </div>
                    )}
                </Container>
            </Col>
        </Row>
    </Container>;
}
